import React, { useState } from 'react';
import { Row, Col, Tab, Accordion, Card } from 'react-bootstrap';
import { useSetTab } from '../../services/hooks';
import { LinkBtn } from '../../components';
import './style.scss';
import CourseDatatable from './CourseDatatable';
import CourseFilter from './CourseFilter';

const CourseIndex = ({ location }) => {
  const [key, setKey] = useSetTab('course-datatable', location, 'course-tab');
  const [showFilters] = useState(true);
  const [activeAccordion, setActiveAccordion] = useState('0');
  const [customParams, setCustomParams] = useState({});
  const [hasSearched, setHasSearched] = useState(false);

  const handleFilterSubmit = values => {
    setCustomParams(values);
    setHasSearched(true);
  };

  return (
    <>
      <Row className="mt-4 mb-4">
        <Col>
          <h2 className="mt-3 mb-3">Administración de Cursos</h2>
        </Col>
        <Col md={3} className="px-md-0 pr-xl-2 my-3 mr-md-2 d-flex justify-content-end">
          <LinkBtn variant="primary" className="mb-1" to="/courses/new">
            Nuevo Curso
          </LinkBtn>
        </Col>
      </Row>
      <Accordion className="my-4" activeKey={activeAccordion} onSelect={eventKey => setActiveAccordion(eventKey)}>
        <Card className="mb-2">
          <Col className="top-header-employee py-2">
            <Accordion.Toggle
              as={Col}
              eventKey="0"
              className="card-header-title d-flex justify-content-between align-items-center"
              onClick={() => setActiveAccordion(activeAccordion === '0' ? null : '0')}
              style={{ textAlign: 'right', cursor: 'pointer' }}
            >
              <span>Filtros de Búsqueda</span>
              <span className="h4 mr-2">{activeAccordion === '0' ? '−' : '+'}</span>
            </Accordion.Toggle>
          </Col>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="employee-filters">
              {showFilters && <CourseFilter formRequest={handleFilterSubmit} />}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
      {hasSearched ? (
        <Tab.Container id="course-datatables.tabs" activeKey={key} mountOnEnter onSelect={k => setKey(k)}>
          <Tab.Content>
            <Tab.Pane eventKey="course-datatable">
              <Row>
                <Col md={12} className="data-table-yellow">
                  <CourseDatatable customParams={customParams} />
                </Col>
              </Row>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      ) : null}
    </>
  );
};

export default CourseIndex;
